'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const NewsletterSubscription = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isHydrated && email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail('');
      }, 3000);
    }
  };

  if (!isHydrated) {
    return (
      <div className="bg-muted border border-border p-xl">
        <div className="flex items-center space-x-sm mb-md">
          <Icon name="EnvelopeIcon" size={20} variant="outline" className="text-primary" />
          <h3 className="text-xl font-light tracking-wide text-primary">
            Legal Intelligence Subscription
          </h3>
        </div>
        
        <p className="text-sm text-text-secondary mb-lg leading-relaxed">
          Receive exclusive arbitration insights, regulatory updates, and market intelligence directly to your inbox.
        </p>
        
        <form className="flex flex-col sm:flex-row gap-sm">
          <input
            type="email"
            placeholder="Your email address"
            className="flex-1 px-md py-sm bg-background border border-border text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-primary transition-colors duration-base"
          />
          <button
            type="submit"
            className="px-lg py-sm bg-primary text-primary-foreground hover:bg-secondary transition-colors duration-base whitespace-nowrap"
          >
            Subscribe
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="bg-muted border border-border p-xl">
      <div className="flex items-center space-x-sm mb-md">
        <Icon name="EnvelopeIcon" size={20} variant="outline" className="text-primary" />
        <h3 className="text-xl font-light tracking-wide text-primary">
          Legal Intelligence Subscription
        </h3>
      </div>
      
      <p className="text-sm text-text-secondary mb-lg leading-relaxed">
        Receive exclusive arbitration insights, regulatory updates, and market intelligence directly to your inbox.
      </p>
      
      {isSubmitted ? (
        <div className="flex items-center space-x-sm p-md bg-success text-success-foreground">
          <Icon name="CheckCircleIcon" size={20} variant="solid" />
          <span className="text-sm">Successfully subscribed to legal intelligence updates</span>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-sm">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            required
            className="flex-1 px-md py-sm bg-background border border-border text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-primary transition-colors duration-base"
          />
          <button
            type="submit"
            className="px-lg py-sm bg-primary text-primary-foreground hover:bg-secondary transition-colors duration-base whitespace-nowrap"
          >
            Subscribe
          </button>
        </form>
      )}
    </div>
  );
};

export default NewsletterSubscription;